import { render, staticRenderFns } from "./ModalCompartilhamentoRelatorio.vue?vue&type=template&id=69dcef10&lang=pug"
import script from "./ModalCompartilhamentoRelatorio.vue?vue&type=script&lang=js"
export * from "./ModalCompartilhamentoRelatorio.vue?vue&type=script&lang=js"
import style0 from "./ModalCompartilhamentoRelatorio.vue?vue&type=style&index=0&id=69dcef10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports